/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetProductBrandsResponse } from '../models/get-product-brands-response';
import { PageableRequest } from '../models/pageable-request';
@Injectable({
  providedIn: 'root',
})
class ProductBrandService extends __BaseService {
  static readonly postApiProductBrandListPath = '/api/ProductBrand/List';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param body undefined
   * @return Success
   */
  postApiProductBrandListResponse(body?: PageableRequest): __Observable<__StrictHttpResponse<GetProductBrandsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/ProductBrand/List`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetProductBrandsResponse>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postApiProductBrandList(body?: PageableRequest): __Observable<GetProductBrandsResponse> {
    return this.postApiProductBrandListResponse(body).pipe(
      __map(_r => _r.body as GetProductBrandsResponse)
    );
  }
}

module ProductBrandService {
}

export { ProductBrandService }
